import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurveService } from 'src/app/shared/curve-service/curve.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { DatePipe } from '@angular/common'
import { TicketService } from 'src/app/shared/customer/ticket/ticket.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup,Validators } from '@angular/forms';
import { CustomerService } from 'src/app/shared/customer/customer.service';
import { AlloyService } from 'src/app/shared/alloy/alloy.service';

@Component({
    selector: 'app-view-all-graphs',
    templateUrl: './view-all-graphs.component.html',
    styleUrls: ['./view-all-graphs.component.css'],
    standalone: false
})
export class ViewAllGraphsComponent implements OnInit {

  alloys
  role: string;
  serverErrorMessages: string;
  graphs = [];
  allgraphs
  loading: boolean = true
  check: boolean = false
  closeResult: string;
  ticketForm = new FormGroup({
    ticket: new FormControl('')
  })
  graph: {}
  graphDetails;
  balance;
  startDate;
  iron1
  iron2
  grade
  drp_grade1=[]
  gIron = ['','Grey Iron','Ductile Iron']
  ironType = ['','Base Iron','Final Iron']
  endDate;
  filterForm = new FormGroup({
    startDate: new FormControl('',[Validators.required]),
    endDate: new FormControl('',[Validators.required]),
    iron1: new FormControl('',[Validators.required]),
    iron2: new FormControl('',[Validators.required]),
    grade: new FormControl(''),
  })
  missingFields = false

  file: File;

  imageUrl: string | ArrayBuffer = "";
  fileName: string = "No file selected";

  constructor(private loginService: LoginService, private router : Router, private curveService: CurveService,private ticketService: TicketService, private datePipe: DatePipe, private modalService: NgbModal, private customerService: CustomerService, private alloyService: AlloyService,) {
    this.customerService.getCurrentBalance().subscribe(
      res => {
       //console.log('got balace', res);
        this.balance = res['balance'][0]['credit'];
        this.customerService.balanceEmitter.next(res['balance'][0]['credit']);
        localStorage.setItem('balance', JSON.stringify(res['balance'][0]['credit']));
      },
      err => {
       //console.log('error getting balance', err)
      }
    )
  }

  ngOnInit(): void {
    this.endDate = this.transformDate(new Date());
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllAlloys();
          this.getAllGraphs();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )

    }
  }
  getAllAlloys(){
    this.alloyService.getAlloy().subscribe(
      res => {
         this.alloys = res['alloyDatas'];
        for (var x of this.alloys) {
          //alert(JSON.stringify(this.alloys))
          if (x.greyIron.baseIron) {
            x.iron1="Grey Iron";
            x.iron2="Base Iron";
            this.drp_grade1.push(x.grade)
          }
          else if (x.greyIron.finalIron) {
            x.iron1="Grey Iron";
            x.iron2="Final Iron";
          }
          else if (x.ductileIron.baseIron) {
            x.iron1="Ductile Iron";
            x.iron2="Base Iron";
            this.drp_grade1.push(x.grade)

          }
          else if (x.ductileIron.finalIron) {
            x.iron1="Ductile Iron";
            x.iron2="Final Iron";

          }
        }
       //console.log('Got alloys', this.alloys)
      },
      err=>{
       //console.log('Error getting alloys', err);
        this.serverErrorMessages = err.error.message
      }
    )

  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllGraphs(){

    this.curveService.getCurveData().subscribe(
      res => {
      console.log('got all graphs', res);
        this.allgraphs = res['curveDatas'];
        var i=0;
        for (var x of this.allgraphs) {
          for (var y of this.alloys) {
            if (y._id == x.alloyId) {
              x.iron1 = y.iron1;
              x.iron2 = y.iron2;
              x.grade = y.grade;
              break;
            }
          }
        }
        this.graphs = this.allgraphs;
        this.loading = false;
      },
      err => {
       //console.log('error getting all graphs', err);
        this.serverErrorMessages = err.error.message;
      }
    )
  }
  sendCurveDataToAnalyser(id, paymentStatus, heatNumber){
    //console.log(paymentStatus)
    let CP,ACEL,TES;
    this.curveService.getCurveDataById({curveId: id}).subscribe( (res)=>{
    console.log('got curve details', res);
    this.graphDetails = res['curveData'];
    console.log("graph"+this.graphDetails);
    console.log(this.graphDetails.thermalValues.Chill,this.graphDetails.thermalValues.ACEL,this.graphDetails.thermalValues.TES);
    },
      err => {
        alert("error fetching curve data!")
    },()=>{

            CP = this.graphDetails.thermalValues.CarbonPercentage
            ACEL = this.graphDetails.thermalValues.ACEL
            TES = this.graphDetails.thermalValues.TES
          //to view all curves please change false to true
            if(CP <=0 || ACEL<=0 || TES<=0 || !CP || !ACEL || !TES)
              this.check = true;
            else
              this.check = true;

            if(this.check)
            {
              this.checkBalanceAndDebit(id, paymentStatus,heatNumber);
              this.curveService.getCurveDataById({curveId: id}).subscribe(res=>{
              ////console.log('got curve details', res);
              this.graphDetails = res['curveData'];
             console.log(this.graphDetails.thermalValues)
            },
            err => {
             //console.log('got error', err)
            })
              //this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:id, heatNumber:heatNumber})
              //this.router.navigateByUrl('analyze-curve');
            }
            else{
              alert("Incorrect Curve data! Please Retake the sample.")
            }

    })

  }

  open(content, graph) {
    ////console.log(content, typeof(content))
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.graph = graph
     console.log('got graph', this.graph)
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  saveTicket(){
  //  console.log(typeof(this.graph['_id']));
    this.ticketService.raiseTicket({message: this.ticketForm.get('ticket').value, curveData: this.graph['_id'], role : "CUSTOMER"},this.file).subscribe(
      res => {
       //console.log('Ticket Generated', res);
        alert("Ticket raised successfully! We will reach out to you soon. Thank you for the patience.");
        alert("Responses will be done from 08:30 AM to 05:00 PM on working days");
        // this.router.navigateByUrl('/home');
      },
      err => {
       console.log('Error generating ticket contact admin papa', err);
       alert(err.error.message)
        this.serverErrorMessages = err.error.message
      });
  }

  checkBalanceAndDebit(curveId, paymentStatus,heatNumber){
    if(!paymentStatus){
      if(window.confirm('Confirm to Pay to view this curve'))
      {
        this.customerService.getCurrentBalance().subscribe(
          balance => {
            this.customerService.balanceEmitter.next(balance['balance'][0]['credit'])
            localStorage.setItem('balance', JSON.stringify(balance['balance'][0]['credit']))
           //console.log('got balance', balance['balance'][0]['credit']);
            this.balance = balance['balance'][0]['credit']
            if(this.balance <= 0){
              window.alert('Insufficient Balance! Please add credit');
            }
            this.customerService.debitPerTransaction({curveId:curveId}).subscribe(
              res => {
               //console.log('successfully debited', res)
                localStorage.removeItem('balance')
                this.customerService.getCurrentBalance().subscribe(
                  res => {
                   //console.log('got balace', res);
                    this.balance = res['balance'][0]['credit'];
                    this.customerService.balanceEmitter.next(res['balance'][0]['credit']);
                    localStorage.setItem('balance', JSON.stringify(res['balance'][0]['credit']));
                  },
                  err => {
                   //console.log('error getting balance', err)
                  }
                )
               //console.log('reloading........')
              // alert(this.graphDetails.thermalValues);

//-----20/05/2022  call function of calculations-----

//main(temperature, time)

               this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:'paid', curveID:curveId, heatNumber:heatNumber, heatId: this.graphDetails.heatId})
               this.router.navigateByUrl('analyze-curve');
               //this.sendCurveDataToAnalyser(curveId, 'paid',heatNumber);
                //window.location.reload();

              },
              err =>{
               //console.log('error while debting', err)
              }
            )
          },
          err => {
           //console.log('error getting balance', err)
          }
        )
      }
    }else{
      //alert(this.graphDetails.thermalValues);
      this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives, paid:this.graphDetails.paid, curveID:curveId, heatNumber:heatNumber ,heatId: this.graphDetails.heatId})
      this.router.navigateByUrl('analyze-curve');
      //this.sendCurveDataToAnalyser(curveId, 'paid',heatNumber);
     //console.log('already paid')
    }
  }

  filter(){
    this.startDate=this.transformDate(this.filterForm.get('startDate').value)
    this.endDate=this.transformDate(this.filterForm.get('endDate').value)
    this.iron1=this.filterForm.get('iron1').value
    this.iron2=this.filterForm.get('iron2').value
    this.grade = this.filterForm.get('grade').value
    if (!this.startDate && !this.endDate && !this.iron1 && !this.iron2) this.missingFields=true
    else {
      // this.filterForm.reset()
      this.missingFields=false
      this.graphs=[];
      console.log(this.startDate, this.endDate)
      for (var x of this.allgraphs) {
        var d = this.transformDate(x.createdAt)
        //var d = x.createdAt
        var gr = x.grade;
        if (d>=this.startDate && d<=this.endDate && x.iron1==this.iron1 && x.iron2==this.iron2 && this.grade=="") {
            if(this.grade)
            {
              if(gr.toLowerCase().indexOf(this.grade.toLowerCase())>-1)
              {
                this.graphs.push(x)
              }
            }
            else
            {
              this.graphs.push(x)
            }

          //for dynamic filtration of curve data
        }else if(d>=this.startDate && d<=this.endDate && this.iron1=="" && this.iron2=="" && this.grade==""){
          if(this.grade)
            {
              if(gr.toLowerCase().indexOf(this.grade.toLowerCase())>-1)
              {
                this.graphs.push(x)
              }
            }
            else
            {
              this.graphs.push(x)
            }

        }else if(d>=this.startDate && d<=this.endDate && this.iron1==x.iron1 && this.iron2==""){
          if(this.grade)
            {
              if(gr.toLowerCase().indexOf(this.grade.toLowerCase())>-1)
              {
                this.graphs.push(x)
              }
            }
            else
            {
              this.graphs.push(x)
            }

        }else if(d>=this.startDate && d<=this.endDate && this.iron1==x.iron1 && this.iron2==x.iron2){
          if(this.grade)
            {
              if(gr.toLowerCase().indexOf(this.grade.toLowerCase())>-1)
              {
                this.graphs.push(x)
              }
            }
            else
            {
              this.graphs.push(x)
            }

        }
      }
      console.log("New graphs", this.graphs)
    }
  }

  reset() {
    this.filterForm.reset()
    this.missingFields=false
    this.graphs = this.allgraphs;
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
        console.log(this.imageUrl)
      };

    }
  }

}
